import React, { Component } from "react";
import { login } from "../Auth/auth";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "", error: false };
  }

  handleChange(event) {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleClick(event) {
    event.preventDefault();
    const { email, password } = this.state;
    login(email, password).then((ok) => {
      if (ok) {
        this.props.onLogin();
      } else {
        this.setState({ error: true });
      }
    });
  }

  render() {
    const { email, password, error } = this.state;
    return (
      <div className="container my-5">
        <div className="row">
          <h3>Page de connexion</h3>
        </div>
        <div className="row my-3">
          <form>
            <div className="field">
              <label className="label">Email</label>
              <div className="control">
                <input
                  className="input"
                  type="text"
                  name="email"
                  value={email}
                  onChange={this.handleChange.bind(this)}
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Password</label>
              <div className="control">
                <input
                  className="input"
                  type="password"
                  name="password"
                  value={password}
                  onChange={this.handleChange.bind(this)}
                />
              </div>
            </div>
            <div className="field">
              <p className="help is-danger">
                {error && "Identifiant et/ou mot de passe invalide(s). "}
              </p>
              <div className="control">
                <button
                  className="button bg-primary is-link"
                  onClick={this.handleClick.bind(this)}
                >
                  Login
                </button>
              </div>
              <p className="my-5">
                Vous n'avez pas de compte ?{" "}
                <Link
                  to={`/compte/creer-compte`}
                  className="text-primary text-decoration-none itemTri"
                >
                  Créer un compte
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
